import React, { useState } from 'react';
import { MdClose, MdCheck, MdContentCopy } from 'react-icons/md';
import { FaXTwitter, FaFacebook, FaLinkedin } from 'react-icons/fa6';
import { BadgeIcon } from './badgeData';

export function BadgeShareModal({ badge, onClose }) {
  const [copied, setCopied] = useState(false);
  if (!badge) return null;

  const shareUrl = window.location.origin;
  const shareText = `I just earned the "${badge.name}" badge on CIVOTE! Join me in making your voice heard on civic issues.`;

  const shareOnTwitter = () => {
    window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`, '_blank');
  };
  const shareOnFacebook = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}&quote=${encodeURIComponent(shareText)}`, '_blank');
  };
  const shareOnLinkedIn = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`, '_blank');
  };
  const copyToClipboard = () => {
    navigator.clipboard.writeText(`${shareText} ${shareUrl}`);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60] p-4" onClick={onClose}>
      <div className="bg-white rounded-2xl p-6 max-w-sm w-full shadow-xl" onClick={e => e.stopPropagation()}>
        <div className="flex justify-between items-center mb-4">
          <h4 className="text-lg font-bold text-gray-800 font-rubik">Share Achievement</h4>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-full transition-colors">
            <MdClose className="text-gray-400 text-xl" />
          </button>
        </div>

        <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl p-4 mb-4 text-center">
          <div 
            className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-2"
            style={{ backgroundColor: badge.color + '20' }}
          >
            <BadgeIcon icon={badge.icon} color={badge.color} size={36} earned={true} />
          </div>
          <p className="font-semibold text-gray-800 font-rubik">{badge.name}</p>
          <p className="text-xs text-gray-500 font-rubik mt-1">Achievement Unlocked!</p>
        </div>

        <div className="grid grid-cols-3 gap-3 mb-4">
          <button
            onClick={shareOnTwitter}
            className="flex flex-col items-center justify-center p-3 rounded-xl bg-black hover:bg-gray-800 text-white transition-colors"
            data-testid="share-twitter"
          >
            <FaXTwitter className="text-xl mb-1" />
            <span className="text-xs">Twitter</span>
          </button>
          <button
            onClick={shareOnFacebook}
            className="flex flex-col items-center justify-center p-3 rounded-xl bg-blue-600 hover:bg-blue-700 text-white transition-colors"
            data-testid="share-facebook"
          >
            <FaFacebook className="text-xl mb-1" />
            <span className="text-xs">Facebook</span>
          </button>
          <button
            onClick={shareOnLinkedIn}
            className="flex flex-col items-center justify-center p-3 rounded-xl bg-blue-700 hover:bg-blue-800 text-white transition-colors"
            data-testid="share-linkedin"
          >
            <FaLinkedin className="text-xl mb-1" />
            <span className="text-xs">LinkedIn</span>
          </button>
        </div>

        <button
          onClick={copyToClipboard}
          className="w-full py-3 px-4 border-2 border-gray-200 rounded-xl font-medium text-gray-700 hover:bg-gray-50 transition-all flex items-center justify-center gap-2"
          data-testid="copy-achievement-link"
        >
          {copied ? (
            <><MdCheck className="text-green-500 text-lg" /> Copied!</>
          ) : (
            <><MdContentCopy className="text-lg" /> Copy to Clipboard</>
          )}
        </button>
      </div>
    </div>
  );
}
